<div class="autocomplete" [class.autocomplete--with-icon]="icon">
  <tp-icon [name]="'icons/' + icon" class="autocomplete__icon"></tp-icon>

  <input
    class="tp-control"
    type="search"
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
    [formControl]="ctrl"
    (blur)="onBlur($event)"
  />

  <div *ngIf="loading" class="autocomplete__spinner">
    <mat-spinner diameter="18"></mat-spinner>
  </div>

  <mat-autocomplete
    [displayWith]="displayFn"
    (optionSelected)="onOptionSelected($event)"
    #auto="matAutocomplete"
  >
    <mat-optgroup *ngFor="let group of optionsGroups" [label]="group.label">
      <mat-option
        *ngFor="let option of group.options"
        [disabled]="option.isDisabled"
        [value]="option"
      >
        {{ option.text }}
      </mat-option>
    </mat-optgroup>
  </mat-autocomplete>
</div>
